import { INewUser, IRedactedUser } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorUserLegalName = (user: INewUser | IRedactedUser) =>
  `${user.profile?.firstName || ""} ${user.profile?.lastName || ""}`.trim();
